import React from 'react';
import data from './swf/data.json';
import QQPet from './index.js';
import '../../global';
import cookie from 'react-cookies';

class InitPet extends React.Component {
  constructor(props) {
    super(props);
    this.state = { data: [] };
    this.barRef = React.createRef();
  }

  end = () => {
    clearInterval(global.pet.Interval1);
    clearInterval(global.pet.Interval2);
    clearInterval(global.pet.Interval3);
    clearInterval(global.pet.Intervalfooter);
    this.props.normal();
    let player = document.querySelector('#container > ruffle-player');
    let item = this.randomChoose(this.search('去')); //入场
    this.barRef.current.BubbleLeave();
    clearTimeout(global.pet.timeout);
    player.load(item.blob);
    let time = (1000 * item.frame) / item.speed;
    setTimeout(this.barRef.current.BubbleOff, time);
    setTimeout(this.props.end, time);
    let inFifteenMinutes = new Date(
      new Date().getTime() + 7 * 24 * 3600 * 1000,
    ); //一周
    cookie.save('now', '成长中', { path: '/', expires: inFifteenMinutes });
  };

  search = name => {
    let index = [];
    this.state.data.forEach(item => {
      if (item.name === name) index.push(item.id);
    });
    return index;
  };

  randomChoose = index => {
    if (index.length > 1)
      return this.state.data[index[Math.floor(index.length * Math.random())]];
    else return this.state.data[index[0]];
  };

  feed = () => {
    this.barRef.current.showfeed();
  };

  clean = () => {
    this.barRef.current.showclean();
  };

  medicine = () => {
    this.barRef.current.showmedicine();
  };

  work = () => {
    this.barRef.current.showwork();
  };

  study = () => {
    this.barRef.current.showstudy();
  };

  componentDidMount() {
    //遍历 预下载swf到本地blob
    data.forEach(item => {
      fetch(item.path)
        .then(res => res.blob())
        .then(blob => {
          // 将链接地址字符内容转变成blob地址
          item.blob = URL.createObjectURL(blob);
        });
    });
    this.setState({ data: data });
  }

  render() {
    return this.props.show ? (
      <QQPet
        data={data}
        ref={this.barRef}
        work={this.props.work}
        study={this.props.study}
        normal={this.props.normal}
      />
    ) : null;
  }
}
export default InitPet;
